module.exports = __webpack_public_path__ + "static/media/a-4.0f3035b5.png";